import { useEffect, useState } from "react";
import GetOrders from "../../Orders/api/GetOrders";
import MainHeader from "../components/MainHeader";
import MainOrdersTable from "../components/MainOrdersTable";

export default function Main() {
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    // // Get the current date and time
    const currentDate = new Date();

    // // Calculate the date and time 24 hours ago
    const twentyFourHoursAgo = new Date(currentDate);
    twentyFourHoursAgo.setHours(currentDate.getHours() - 24);

    // get Order Dat from API
    const getOrderData = async () => {
      let OrdersList = await GetOrders();

      // Parse local string dates to Date objects
      const parsedOrders = OrdersList.map((order) => ({
        ...order,
        orderDate: new Date(order.orderdate),
      }));

      // Filter orders for the last 24 hours
      const filtered = parsedOrders.filter((order) => order.orderDate >= twentyFourHoursAgo);
      setOrders(filtered);
    };

    getOrderData();
  }, []);
  return (
    <>
      <MainHeader orders={orders} />
      {/* Container for Main Clients and latest Order */}
      <main className="container mx-auto md:p-8">
        <div className="flex flex-col md:flex-row">
          <MainOrdersTable orders={orders} />
        </div>
      </main>
    </>
  );
}
